import React from 'react';
import moment from 'moment';
import 'moment/locale/es'; // Importa el locale español

/**
 * Formatea la fecha de última conexión a la hora local del usuario.
 * Maneja ISO 8601 UTC, timestamps Unix (numéricos y en cadena) y maneja errores robustamente.
 */
function formatearUltimaConexionLocal(lastConnection: string | number | null | undefined): string {
  if (!lastConnection) {
    return "Nunca se ha conectado.";
  }

  try {
    let lastConnectionMoment;

    if (typeof lastConnection === 'number') {
      lastConnectionMoment = moment(lastConnection);
    } else if (typeof lastConnection === 'string') {
      let timestampNumber = (lastConnection);
          lastConnectionMoment = moment.utc(lastConnection);
          if (!lastConnectionMoment.isValid()) {
                lastConnectionMoment = moment(lastConnection)
              if (!lastConnectionMoment.isValid()){
                return `Formato de fecha inválido: ${lastConnection}`;
            }
          }
      
    } else {
      return "Formato de fecha inválido.";
    }

    if (!lastConnectionMoment || !lastConnectionMoment.isValid()) { // Corrección crucial
      return "Fecha inválida.";
    }

    const ahoraLocal = moment();

    const diffMinutes = ahoraLocal.diff(lastConnectionMoment, 'minutes');
    const diffHours = ahoraLocal.diff(lastConnectionMoment, 'hours');
    const diffDays = ahoraLocal.diff(lastConnectionMoment, 'days');

    if (diffMinutes < 1) {
      return "Activo en linea";
    } else if (diffMinutes < 60) {
      return `Activo hace ${diffMinutes} minuto${diffMinutes > 1 ? 's' : ''}`;
    } else if (diffHours < 24) {
      return `Activo hace ${diffHours} hora${diffHours > 1 ? 's' : ''}`;
    } else if (diffDays === 1) {
      return "Activo ayer";
    } else if (diffDays < 7) {
      return `Activo el ${lastConnectionMoment.format('dddd')}`;
    } else {
      return `Activo el ${lastConnectionMoment.format('DD/MM/YYYY')}`;
    }
  } catch (error) {
    console.error("Error al formatear la fecha de última conexión:", error, lastConnection);
    return "Fecha inválida.";
  }
}

interface LastConnectionProps {
  lastConnection: string | number | null | undefined;
}

const LastConnection: React.FC<LastConnectionProps> = ({ lastConnection }) => {
  const formattedLastConnection = formatearUltimaConexionLocal(lastConnection);

  const isOnline = formattedLastConnection === "Activo en linea";

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {isOnline && (
        <span
          style={{
            display: 'inline-block',
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: '#22c55e', // tailwind green-500
            marginRight: 4,
          }}
          aria-label="En línea"
        />
      )}
      {formattedLastConnection}
    </div>
  );
};

export default LastConnection;